import Fields from "./BrigadeiroCalculatorFields";
import Result from "./BrigadeiroCalculatorResult";
import Description from "./BrigadeiroCalculatorDescription";
import calculate from "./calculate";
import Custom from "../customCalculator/CustomCalculatorFormContainer";

const BrigadeiroCalculator = { Description, Fields, Result, calculate, Custom };

export default BrigadeiroCalculator;
